import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchBotDetail, fetchBotList } from '@/services/bot';

export interface BotState {
  events: any
}

const initialState: BotState = {
  events: [],
};

export const getBotDetail = createAsyncThunk('bot/detail', fetchBotDetail);
export const getBotList = createAsyncThunk('bot/list', fetchBotList);

export const event = createSlice({
  name: 'event',

  initialState,

  reducers: {
    clearEvent() {
      return initialState;
    },

    createNewEvent(state) {
      state.events = [];
    },
  },
});

export const { clearEvent, createNewEvent } = event.actions;

export default event.reducer;
